import { Platform } from 'react-native';

/** Web sidebar breakpoint (single source of truth — shared/layout). */
export const WEB_SIDEBAR_BREAKPOINT = 960;

/** App sidebar width in pixels (web shell). */
export const APP_SIDEBAR_WIDTH = 220;

/** Content switches to wide layout (tables, multi-column KPIs). Platform-agnostic. */
export const CONTENT_WIDE_BREAKPOINT = 768;

/** Max readable width for form modals on web. */
export const CONTENT_MAX_WIDTH_FORM = 640;

/** Settings / account screens inside shell. */
export const CONTENT_MAX_WIDTH_SETTINGS = 880;

/** Admin tables and dense data modals. */
export const CONTENT_MAX_WIDTH_DATA = 720;

/** Wide data tabs (catalog, inventory tables). */
export const CONTENT_MAX_WIDTH_DATA_WIDE = 1200;

/** Auth card (login). */
export const CONTENT_MAX_WIDTH_AUTH = 420;

/** Small utility modals (sync health). */
export const CONTENT_MAX_WIDTH_COMPACT = 520;

/** Settings on web with sidebar — slightly wider than mobile cap. */
export const CONTENT_MAX_WIDTH_SETTINGS_WIDE = 960;

export type ScreenLayoutVariant =
  | 'default'
  | 'form'
  | 'settings'
  | 'settingsWide'
  | 'data'
  | 'dataWide'
  | 'auth'
  | 'compact';

/** Cambiar sucursal con sucursal activa: overlay dialog sobre el shell (web ≥ breakpoint). */
export function isWebBranchSwitchOverlay(windowWidth: number, hasActiveBranch: boolean): boolean {
  return hasActiveBranch && Platform.OS === 'web' && windowWidth >= WEB_SIDEBAR_BREAKPOINT;
}

export function contentMaxWidthForVariant(variant: ScreenLayoutVariant): number | undefined {
  switch (variant) {
    case 'form':
      return CONTENT_MAX_WIDTH_FORM;
    case 'settings':
      return CONTENT_MAX_WIDTH_SETTINGS;
    case 'settingsWide':
      return CONTENT_MAX_WIDTH_SETTINGS_WIDE;
    case 'data':
      return CONTENT_MAX_WIDTH_DATA;
    case 'dataWide':
      return CONTENT_MAX_WIDTH_DATA_WIDE;
    case 'auth':
      return CONTENT_MAX_WIDTH_AUTH;
    case 'compact':
      return CONTENT_MAX_WIDTH_COMPACT;
    default:
      return undefined;
  }
}
